
import CustomImage from '~/components/elements/CustomImage';

export default {
  name: 'BlogArticleReactionIcon',
  components: {CustomImage},
  props: {
    reaction: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onClickHandler() {
      this.$emit('click')
    },
  },
}
